import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", null, "제목", -1)
const _hoisted_7 = { class: "form-group grid" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", null, "내용", -1)
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", null, "미리보기 URL", -1)
const _hoisted_13 = {
  role: "group",
  class: "form-group"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  class: "col-form-label col-sm-3",
  style: {"padding-left":"0px"}
}, " 앱 ", -1)
const _hoisted_15 = {
  class: "col-sm-12",
  style: {"padding-left":"0px"}
}
const _hoisted_16 = /*#__PURE__*/_createVNode("option", { value: "0" }, "어신", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("option", { value: "1" }, "파트너스", -1)
const _hoisted_18 = {
  role: "group",
  class: "form-group"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("label", {
  class: "col-form-label col-sm-3",
  style: {"padding-left":"0px"}
}, " OS ", -1)
const _hoisted_20 = {
  class: "col-sm-12",
  style: {"padding-left":"0px"}
}
const _hoisted_21 = /*#__PURE__*/_createVNode("option", {
  value: "0",
  selected: ""
}, "전체", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("option", { value: "1" }, "iOS", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("option", { value: "2" }, "Android", -1)
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "col-sm-9" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", null, "노출 여부", -1)
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "col-sm-9" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", null, "상단 고정 여부", -1)
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "col-sm-9" }
const _hoisted_38 = /*#__PURE__*/_createVNode("label", null, "화면 좌우 여백 없애기", -1)
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, "수정", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor = _resolveComponent("editor")
  const _component_file_upload = _resolveComponent("file-upload")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("form", {
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
        class: { loading: _ctx.loading }
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.notification.title = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.notification.title]
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_editor, {
                ref: "customEditor",
                "set-contents": _ctx.notification.description
              }, null, 8, ["set-contents"])
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_file_upload, {
                ref: "thumbnailFile",
                title: "Thumbnail",
                "set-preview-img": _ctx.previewImg,
                "folder-name": 'notification'
              }, null, 8, ["set-preview-img"])
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.notification.contents_url = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.notification.contents_url]
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode("div", _hoisted_15, [
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.notification.app = $event)),
                  required: ""
                }, [
                  _hoisted_16,
                  _hoisted_17
                ], 512), [
                  [_vModelSelect, _ctx.notification.app]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode("div", _hoisted_20, [
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.notification.os = $event)),
                  required: ""
                }, [
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23
                ], 512), [
                  [_vModelSelect, _ctx.notification.os]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode("div", _hoisted_27, [
                  _createVNode("label", _hoisted_28, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.notification.show = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.notification.show]
                    ]),
                    _hoisted_29
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode("div", _hoisted_33, [
                  _createVNode("label", _hoisted_34, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.notification.pin = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.notification.pin]
                    ]),
                    _hoisted_35
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode("div", _hoisted_39, [
                  _createVNode("label", _hoisted_40, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.notification.no_margin_layout = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.notification.no_margin_layout]
                    ]),
                    _hoisted_41
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_42
      ], 34)
    ])
  ]))
}